<ch-header #header>
  <header class="navbar w-100 shadow-sm fixed-top p-2" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">
    <div class="row w-100">

      <div class="col-4 ps-3">
        <a [routerLink]="'/'">
            <div class="logo-container">
              <img src="assets/FXCH.v2.1.png" alt="fxch-logo" height="100%"/>
            </div>
        </a>
        <div class="logo-txt" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">Rates</div>
      </div>

      <div class="col-16">
<!--        <h4 class="text-center text-uppercase text-primary mb-0" [ngClass]="darkModeService.isDarkModeOn() ? 'text-secondary' : 'text-primary'">Rates</h4>-->
        <h4 class="text-center text-uppercase text-primary mb-0">Rates</h4>
      </div>

      <div class="col-4 text-end pe-0">
        <button class="btn btn-outline-primary" (click)="header.logout()">
          Sign out <i class="fa fa-lg fa-sign-out"></i>
        </button>
        <ch-sidenav-btn></ch-sidenav-btn>
      </div>



    </div>
  </header>
</ch-header>

<div class="table-container first-block">
<table class="table table-bordered table-hover" [ngClass]="{'dark-skin': darkModeService.isDarkModeOn()}">
  <thead>
  <tr>
    <th scope="col" class="col-id">
<!--      <div (click)="setOrder('valueDate')" class="order-container">-->
<!--        <i class="fa" [ngClass]="getClass('valueDate')"></i>-->
<!--        <i *ngIf="!order['valueDate']" class="fa fa-angle-up disabled"></i>-->
<!--        <span class="badge rounded-pill" *ngIf="order['valueDate']">{{order['valueDate'].order}}</span>-->
<!--      </div>-->

      Currency pair
    </th>
    <th scope="col">Bid</th>
    <th scope="col">Offer</th>
    <th scope="col">Bid Updated at</th>
    <th scope="col">Offer Updated at</th>
    <th scope="col" class="col-edit"></th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let item of orderedRates">
    <td class="text-center">{{item.currencyPair}}</td>
    <td>{{item.bid}}</td>
    <td>{{item.offer}}</td>
    <td>{{item.bidUpdatedAt | date }}</td>
    <td>{{item.offerUpdatedAt | date }}</td>
    <td class="text-center">

      <i class="fa fa-lg fa-pencil" (click)="updateRates(item)"></i>

    </td>
  </tr>
</table>
</div>
